import axios from "axios";
import cachios from "cachios";

const cacheAxiosInstance = axios.create({
	baseURL: 'https://api.aref-medical.com',
	headers:{
		'x-center-token':'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZW50ZXJJZCI6IjE1Iiwicm9sZSI6InVzZXIiLCJpYXQiOjE2OTkwOTIzMTN9.GeqgwwLs3X6QdiPN36YIyul51AvBqsNqcCi62SnxUkw',
	}
})

export const cachiosInstance = cachios.create(cacheAxiosInstance);
